exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-0ed12974] {\r\n  width: 350px !important;\n}\r\n", ""]);

// exports
